import clsx from "clsx";
import { FadeIn } from "~/components/animations";
import { BG } from "~/components/theme/colors";

type SectionStripProps = {
  title: string;
  bgClassName?: string;
  paddingClassName?: string;
  titleClassName?: string;
  className?: string;
};

const SectionStrip: React.FC<SectionStripProps> = ({
  title,
  bgClassName = "bg-gray-200",
  paddingClassName = "px-4 py-12 sm:py-16 lg:px-8",
  titleClassName = "font-semibold h2",
  className,
}) => {
  return (
    <article
      className={clsx(
        "mt-10 flex h-[100px] flex-col items-center justify-center gap-4 text-center text-2xl h3",
        bgClassName ?? BG.light,
        paddingClassName,
        className
      )}
    >
      <FadeIn direction="up" duration={0.6}>
        <h2 className={clsx("heading-inherit-color", titleClassName)}>{title}</h2>
      </FadeIn>
    </article>
  );
};

export default SectionStrip;
